import formatDate from "@/utils/formatDate"
import formatResult from "@/utils/formatResult"
import clsx from "clsx"
import Button from "./Button"

const GameUploadSelect = ({
  games,
  selectedIndexes,
  selectGame,
  selectAllGames,
  next,
  previous,
}: {
  games: any[]
  selectedIndexes: number[]
  selectGame: (index: number) => void
  selectAllGames: () => void
  next: () => void
  previous: () => void
}) => {
  const noneSelected = selectedIndexes.length === 0
  const allSelected = selectedIndexes.length === games.length
  const tooManyGames = selectedIndexes.length > 100

  return (
    <div className="mt-4 sm:mt-6">
      <div className="flex items-center gap-1.5">
        <p className="text-gray-700">
          <span className="font-semibold">{selectedIndexes.length}</span> of{" "}
          <span className="font-semibold">{games.length}</span>{" "}
          {games.length === 1 ? "game" : "games"} selected.
        </p>
        <button
          onClick={selectAllGames}
          className="text-chessdrop-500 hover:text-chessdrop-700 font-medium"
        >
          {allSelected ? "Deselect all" : "Select all"}
        </button>
      </div>

      <ol className="mt-4 max-h-[550px] divide-y divide-gray-300 overflow-x-hidden overflow-y-auto rounded-lg border border-gray-300 sm:mt-6">
        {games.map((game, index) => {
          const selected = selectedIndexes.includes(index)
          const formattedDateString = game.date?.replace(/\./g, "-")
          const gameDate = new Date(formattedDateString ?? "")

          return (
            <li key={index}>
              <button
                className={clsx(
                  "flex w-full items-center justify-between space-x-3 px-3 py-2.5 text-sm sm:space-x-2",
                  selected ? "bg-chessdrop-500/5" : "bg-white"
                )}
                onClick={() => selectGame(index)}
              >
                <span className="flex items-center space-x-3 sm:space-x-2">
                  <span
                    className={clsx(
                      "h-2 w-2 rounded-full border",
                      selected
                        ? "border-chessdrop-700 bg-chessdrop-500"
                        : "border-gray-400 bg-gray-200"
                    )}
                  />
                  <span className="block w-8 shrink-0 text-center text-sm text-gray-900">
                    {formatResult(game.result ?? "")}
                  </span>
                  <span className="flex flex-col gap-y-2 sm:flex-row">
                    {game.title ? (
                      <span className="text-left text-gray-900">
                        {game.title}
                      </span>
                    ) : (
                      <span className="line-clamp-1 text-left leading-tight text-gray-900">
                        {game.white?.name ?? "Unknown"}
                        {" – "}
                        {game.black?.name ?? "Unknown"}
                      </span>
                    )}
                    <span className="text-left leading-tight text-gray-500 sm:hidden">
                      {formatDate({
                        date: gameDate,
                        format: "long",
                        timeZone: "UTC",
                      })}
                    </span>
                  </span>
                </span>
                <span className="hidden shrink-0 text-right leading-tight text-gray-500 sm:inline-block">
                  {formatDate({
                    date: gameDate,
                    format: "long",
                    timeZone: "UTC",
                  })}
                </span>
              </button>
            </li>
          )
        })}
      </ol>

      {tooManyGames && (
        <div className="mt-4 text-center text-base font-medium text-red-600">
          You can only import a maximum of 100 games at a time.
        </div>
      )}

      <div className="mt-4 grid grid-cols-3 items-center gap-2.5 sm:mt-6">
        <Button fullWidth style="secondary" onClick={previous}>
          Back
        </Button>
        <Button
          fullWidth
          disabled={noneSelected}
          onClick={next}
          className="col-span-2"
        >
          Continue
        </Button>
      </div>
    </div>
  )
}

export default GameUploadSelect
